// extracted by mini-css-extract-plugin
module.exports = {"scale":"style__scale__v8u-o","scaleItem":"style__scaleItem__AKk6H","marked":"style__marked__Irtkc","textScale":"style__textScale__vakMt"};